import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { UseFormReturn } from "react-hook-form";
import type { AuthProviderCustomForm } from "@/app/oauth/types";

type AuthorizationEndpointFieldProps = {
  form: UseFormReturn<AuthProviderCustomForm, unknown>;
};

export const AuthorizationEndpointField = ({
  form,
}: AuthorizationEndpointFieldProps) => (
  <FormField
    control={form.control}
    name="oauth2.authorize_request.endpoint"
    render={({ field }) => (
      <FormItem>
        <FormLabel>Authorization Endpoint</FormLabel>
        <FormControl>
          <Input placeholder="https://example.com/oauth/authorize" {...field} />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
);
